import React from "react";
import styles from "./GenericFunnelViewer.module.css";

const cleanLines = (block = "") =>
  String(block || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

const stripBoldTitle = (lines = []) => {
  let startIdx = 0;
  for (let i = 0; i < lines.length; i++) {
    if (/^\*\*.*\*\*$/.test(lines[i])) {
      startIdx = i + 1;
      break;
    }
  }
  return lines.slice(startIdx);
};

const stripBullet = (line = "") =>
  line.replace(/^[-*]\s+/, "").replace(/^\d+[).]\s+/, "").trim();

const splitSentences = (text = "") => {
  const raw = String(text || "").trim();
  if (!raw) return [];
  const matches = raw.match(/[^.!?]+[.!?]+|[^.!?]+$/g);
  return (matches || []).map((s) => s.trim()).filter(Boolean);
};

const GenericFunnelViewer = ({ markdown = "", title = "Funnel Insight" }) => {
  if (!markdown) return null;

  const lines = stripBoldTitle(cleanLines(markdown));
  const body = lines.join(" ").trim();
  const bullets = lines.filter((line) => /^[-*]\s+/.test(line) || /^\d+[).]\s+/.test(line));
  const paragraphs = bullets.length ? [] : splitSentences(body);

  return (
    <div className={styles.card}>
      {title ? (
        <div className={styles.hero}>
          <h4 className={styles.heroTitle}>{title}</h4>
        </div>
      ) : null}
      <div className={styles.body}>
        {bullets.length > 0 ? (
          <ul className={styles.list}>
            {bullets.map((line, idx) => (
              <li key={`bullet-${idx}`}>{stripBullet(line)}</li>
            ))}
          </ul>
        ) : (
          paragraphs.map((line, idx) => (
            <p key={`p-${idx}`} className={styles.paragraph}>
              {line}
            </p>
          ))
        )}
      </div>
    </div>
  );
};

export default GenericFunnelViewer;
